import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1de812e0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "installPWA"
};
var _hoisted_2 = {
  key: 0,
  "class": "modal"
};
var _hoisted_3 = {
  "class": "modal-content"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "You can continue to use this in any browser, however if you'd like a native experience, you can install this application.", -1);
});
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "assets/screenshots/Android-icon-installed.png",
    "class": "ios-screenshot"
  }, null, -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "Install this application for a better experience. Like a native application for this device.", -1);
});
var _hoisted_8 = {
  key: 1
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "assets/screenshots/installed_ios.png",
    "class": "ios-screenshot--smaller"
  }, null, -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("b", null, "How to Install:")], -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "1. Click the share icon under the URL bar.", -1);
});
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "assets/screenshots/ios_install_1.png",
    "class": "ios-screenshot--smaller-chunk"
  }, null, -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "2. Click \"Add to Home Screen\"", -1);
});
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "assets/screenshots/ios_install_2.png",
    "class": "ios-screenshot--smaller-chunk"
  }, null, -1);
});
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "If you do not immediately see the \"Add to Home Screen\" button you might have to scroll down to \"edit Actions\" to add the button", -1);
});
var _hoisted_16 = [_hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12, _hoisted_13, _hoisted_14, _hoisted_15];
var _hoisted_17 = {
  key: 1,
  "class": "modal"
};
var _hoisted_18 = {
  "class": "modal-content"
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "Install for IOS", -1);
});
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "assets/screenshots/installed_ios.png",
    "class": "ios-screenshot"
  }, null, -1);
});
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "Did you know that you can install this app for IOS? To do this, simply open this app in safari to enable download and install.", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.showInstallPrompt ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-times",
    "class": "close",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.showInstallPrompt = false;
    })
  }), _createElementVNode("h1", null, _toDisplayString($options.installTitle), 1), _hoisted_4, $data.isAndroid || !$data.isIOS ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _hoisted_7, _createElementVNode("button", {
    "class": "install",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.installApplication && $options.installApplication.apply($options, arguments);
    })
  }, "Install App Now")])) : _createCommentVNode("", true), $data.isIOS ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_16)) : _createCommentVNode("", true), $data.showOptOut ? (_openBlock(), _createElementBlock("button", {
    key: 2,
    "class": "optout",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.optOut && $options.optOut.apply($options, arguments);
    })
  }, "Do Not Show This Again")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), $data.showIOSChromeModal ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-times",
    "class": "close",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $data.showIOSChromeModal = false;
    })
  }), _hoisted_19, _hoisted_20, _hoisted_21, $data.showOptOut ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    "class": "optout",
    onClick: _cache[4] || (_cache[4] = function () {
      return $options.optOut && $options.optOut.apply($options, arguments);
    })
  }, "Do Not Show This Again")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]);
}